import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Table } from "antd";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { EExtendsMergeStrategy, EUserRole, ServiceTemplateField, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useServiceTemplateTechnicalDefinitionsTableColumns, useServiceTemplateTechnicalDefinitionsTableColumnsReadOnly } from "./technical-definitions/columns.js";
import { TechnicalDefinitionsTable } from "./technical-definitions/technical-definitions-table.js";
import { useTranslation } from "../../../../../../others/i18n.js";
import { useStores } from "../../../../../../store/root.js";
import { DEFAULT_PAGINATION_META_DATA } from "../../../../../../types/template/meta-data.js";
import { isExtendedFieldHidden } from "../../../../../../util/template/form.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
const FormFieldServiceTemplateTechnicalDefinitions = observer((props)=>{
    const { form } = props;
    const { t } = useTranslation();
    const { rcbAuthenticationStore } = useStores();
    const hasCreatorRole = rcbAuthenticationStore.hasRole(EUserRole.Creator);
    // DND table for technical definitions
    const technicalDefinitionColumns = useServiceTemplateTechnicalDefinitionsTableColumns(t);
    const displayColumnDefinition = useMemo(()=>useServiceTemplateTechnicalDefinitionsTableColumnsReadOnly(t), [
        t
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.TechnicalDefinitions,
        forceHiddenFormCallback: isExtendedFieldHidden(ServiceTemplateField.TechnicalDefinitions, hasCreatorRole),
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prev, next)=>prev.isEmbeddingOnlyExternalResources !== next.isEmbeddingOnlyExternalResources || prev.extends?.identifier !== next.extends?.identifier || prev.extendedMergeStrategies !== next.extendedMergeStrategies,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                const extendedStrategy = getFieldValue([
                    TemplateMetaDataField.ExtendedMergeStrategies,
                    ServiceTemplateField.IsEmbeddingOnlyExternalResources
                ]);
                const isEmbeddingOnlyExternalResources = getFieldValue(ServiceTemplateField.IsEmbeddingOnlyExternalResources);
                let defaultStrategy = EExtendsMergeStrategy.Keep;
                if (extendedStrategy === EExtendsMergeStrategy.Keep && extended?.isEmbeddingOnlyExternalResources) {
                    defaultStrategy = EExtendsMergeStrategy.Clear;
                } else if (extendedStrategy === EExtendsMergeStrategy.Overwrite && isEmbeddingOnlyExternalResources) {
                    defaultStrategy = EExtendsMergeStrategy.Clear;
                } else if (extendedStrategy === EExtendsMergeStrategy.Clear) {
                    defaultStrategy = EExtendsMergeStrategy.Clear;
                }
                // Hide the form item if the user is embedding only external resources and the template does not extend
                const hide = (isEmbeddingOnlyExternalResources === null || isEmbeddingOnlyExternalResources) && !extended;
                return !hide && /*#__PURE__*/ _jsx(Form.Item, {
                    label: getFieldNameTranslated(ServiceTemplateField.TechnicalDefinitions, t),
                    name: ServiceTemplateField.TechnicalDefinitions,
                    rules: [
                        {
                            min: extended === undefined ? 1 : 0,
                            message: "At least one technical definition is required",
                            type: "array",
                            required: extended === undefined
                        }
                    ],
                    required: true,
                    children: /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                        extendsFieldName: ServiceTemplateField.TechnicalDefinitions,
                        defaultStrategy: defaultStrategy,
                        disableStrategies: getDisableStrategies(true, defaultStrategy === EExtendsMergeStrategy.Clear ? [
                            EExtendsMergeStrategy.Keep,
                            EExtendsMergeStrategy.Append,
                            EExtendsMergeStrategy.Overwrite
                        ] : []),
                        onKeepContent: extended && /*#__PURE__*/ _jsx(Table, {
                            rowKey: "id",
                            pagination: {
                                defaultPageSize: 10,
                                ...DEFAULT_PAGINATION_META_DATA
                            },
                            dataSource: extended[ServiceTemplateField.TechnicalDefinitions],
                            columns: displayColumnDefinition
                        }),
                        children: /*#__PURE__*/ _jsx(TechnicalDefinitionsTable, {
                            form: form,
                            formName: ServiceTemplateField.TechnicalDefinitions,
                            columns: technicalDefinitionColumns
                        })
                    })
                });
            }
        })
    });
});
export { FormFieldServiceTemplateTechnicalDefinitions };
